import { Filter } from "@/types/order-table";
import AdvanceFilter from "./presentational";
import { Metrics } from "@/contexts/metrics-context";
import { Orders } from "@/contexts/orders-context";

interface Props {
  type: Filter;
  useContext: () => Metrics | Orders;
}
const data = ["SUBMIT", "SUBMITTED"];
const AdvanceFilterContainer = ({ type, useContext }: Props) => {
  return (
    <AdvanceFilter type={type} originalList={data} useContext={useContext} />
  );
};

export default AdvanceFilterContainer;
